import { login, logout, getInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import {queryAndUpdateSession} from '@/api/my.js'
import { getUserInfo, setUserInfo } from '../../utils/session'

const state = {
  token: '',
  userInfo: {}
}

const mutations = {
  SET_TOKEN: (state, token) => {
    setToken(token)
  },
  SET_USER_INFO: (state, info) => {
    setUserInfo(JSON.stringify(info))
  }
}

const actions = {
  // 登出
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          commit('SET_TOKEN', '')
          removeToken()
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 获取基本用户信息
  getInfo({ commit}) {
    return new Promise((resolve, reject) => {
      queryAndUpdateSession()
        .then(res => {
          const data = res.result

          console.log("xxxxxrrrrwwwrrrr--------",data)
          if (!data) {
            reject(new Error('获取基本信息失败，请重新登录'))
          }
          commit('SET_USER_INFO', data)
          resolve(data)
        })
        .catch(error => {
          console.log("qqqqqqqqqqqqqqqqqqqq")
          reject(error)
        })
    })
  },

  // 重置token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', null)
      removeToken()
      resolve()
    })
  },

  // 重置token
  setUserAndToken({ commit },data) {
    return new Promise(resolve => {
      commit('SET_USER_INFO', data.userInfo)
      commit('SET_TOKEN', data.token)
      resolve()
    })
  }


}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
